export const Roles = {
  SUPPORT: 'support',
  PHARMACIST: 'pharmacist',
  PHARMACY_ADMIN: 'account_manager',
  PRESCRIBER: 'prescriber',
};

/**
 * Authorization Roles
 */
export const authRoles = {
  support: [Roles.SUPPORT],
  pharmacist: [Roles.SUPPORT, Roles.PHARMACY_ADMIN, Roles.PHARMACIST],
  pharmacyAdmin: [Roles.SUPPORT, Roles.PHARMACY_ADMIN],
  onlyGuest: [],
  prescriber: [Roles.PRESCRIBER],
  prescriberAndSupport: [Roles.PRESCRIBER, Roles.SUPPORT],
  all: Object.values(Roles),
};

export default authRoles;
